import { BehaviorSubject, Subject } from 'rxjs';

import { Injectable } from '@angular/core';

import { UserInfo } from '@shared/models';
import { UserService } from '@shared/services';
import { NotificationGlobalService } from './notification-global.service';
import { NotificationStoreService } from './notification-store.service';
declare global {
	interface Window {
		userLevel: any;
	}
}
@Injectable({
	providedIn: 'root',
})
export class UsersInfoService {
	userProfileSubject = new BehaviorSubject<UserInfo>(new UserInfo());
	userProfile$ = this.userProfileSubject.asObservable();
	public avatarUrl = 'assets/image/no_image_profile.jpg';
	constructor(
		private _userService: UserService,
		private _notifiService: NotificationGlobalService,
		private notiStore: NotificationStoreService
	) {}

	public getUserGroup(): any {
		const group = localStorage.getItem('userGroup');
		if (group) {
			const obj = JSON.parse(group);
			if (obj) {
				return obj;
			}
		}
		return null;
	}

	private saveUserGroup(group: any) {
		this.removeUserGroup();
		const str = JSON.stringify(group);
		localStorage.setItem('userGroup', str);
		sessionStorage.setItem('userGroup', str);
		window.userLevel = group.Level_Id;
	}

	public removeUserGroup() {
		localStorage.removeItem('userGroup');
		sessionStorage.removeItem('userGroup');
	}

	setUserProfile() {
		return new Promise((rs, rj) => {
			this._userService.getUserInfo().subscribe(
				(user: any) => {
					if (user) {
						if (user.Group) {
							this.saveUserGroup(user.Group);
						}
						sessionStorage.removeItem('userID');
						sessionStorage.setItem('userID', user.ID);
						sessionStorage.removeItem('jobTitle');
						sessionStorage.removeItem('jobTitleIsType');
						if (user.Employee) {
							sessionStorage.removeItem('firstName');
							sessionStorage.setItem(
								'firstName',
								user.Employee.Employee_FirstName
							);
							sessionStorage.removeItem('lastName');
							sessionStorage.setItem(
								'lastName',
								user.Employee.Employee_LastName
							);
							sessionStorage.removeItem('email');
							sessionStorage.setItem(
								'email',
								user.Employee.Employee_Email
							);
							sessionStorage.removeItem('employeeId');
							sessionStorage.setItem(
								'employeeId',
								user.Employee.Employee_Id
							);
							sessionStorage.removeItem('avatar');
							if (user.Employee.Employee_Photo) {
								sessionStorage.setItem(
									'avatar',
									user.Employee.Employee_Photo
								);
							} else {
								sessionStorage.setItem(
									'avatar',
									this.avatarUrl
								);
							}
							if (user.Employee.JobTitles['$values'][0]) {
								sessionStorage.setItem(
									'jobTitle',
									user.Employee.JobTitles['$values'][0]
										.Job_Title_Name
								);

								sessionStorage.setItem(
									'jobTitleIsType',
									user.Employee.JobTitles['$values'][0].IsType
								);
							}
						}
						sessionStorage.removeItem('createJobType');
						sessionStorage.setItem(
							'createJobType',
							user.CreateJobType
						);
						this.userProfileSubject.next(user);

						this._notifiService.setParams(user.Company_Id, user.ID);
						// TODO: Re-enable after Chat/Messenger & Push Notifications  is complete (requires jQuery/SignalR)
						// this._notifiService.startReconnectChecker();
						this.notiStore.refreshNotifications();

						this._userService.GetActionAvailable().subscribe(
							data => {
								if (data) {
									sessionStorage.removeItem('permission');
									sessionStorage.setItem(
										'permission',
										JSON.stringify(data['$values'])
									);
									rs(user);
								} else {
									rs(null);
								}
							},
							err => {
								rs(null);
							}
						);

						this._userService.getAllConfigs().subscribe(
							rs => {
								if (rs) {
									sessionStorage.setItem(
										'ALL_CONFIGS',
										JSON.stringify(rs)
									);
								}
							},
							err => {
								console.log(
									'Can not get System Configurations'
								);
							}
						);
					} else {
						rs(null);
					}
				},
				err => {
					rs(null);
				}
			);
		});
	}
}
